import { localize, extend, configure } from 'vee-validate';
import {
  // eslint-disable-next-line camelcase
  required, integer, alpha_dash, min_value, max_value,
  min, max, regex, email, between, confirmed,
} from 'vee-validate/dist/rules';
import installDecimalValidator from './decimalValidator';
import translate from '../../common/localization/translate';

async function loadLocale(language) {
  if (language === 'en') {
    return import('vee-validate/dist/locale/en.json');
  }
  if (language === 'de') {
    return import('vee-validate/dist/locale/de.json');
  }
  if (language === 'es') {
    return import('vee-validate/dist/locale/es.json');
  }
  if (language === 'fr') {
    return import('vee-validate/dist/locale/fr.json');
  }
  if (language === 'it') {
    return import('vee-validate/dist/locale/it.json');
  }
  if (language === 'pl') {
    return import('vee-validate/dist/locale/pl.json');
  }
  if (language === 'ja') {
    return import('vee-validate/dist/locale/ja.json');
  }
  if (language === 'tr') {
    return import('vee-validate/dist/locale/tr.json');
  }
  if (language === 'zh') {
    return import('vee-validate/dist/locale/zh_CN.json');
  }
  return null;
}

function setUpLocalizedDefaultMessage() {
  configure({
    defaultMessage: translate('common.DEFAULT_VALIDATION'),
  });
}

async function localizeVeeValidate(language) {
  setUpLocalizedDefaultMessage();
  const dictionary = await loadLocale(language);
  localize(language, dictionary);
}

function installVeeValidateRules() {
  extend('required', required);
  extend('integer', integer);
  extend('alpha_dash', alpha_dash);
  extend('min_value', min_value);
  extend('max_value', max_value);
  extend('min', min);
  extend('max', max);
  extend('regex', regex);
  extend('email', email);
  extend('between', between);
  extend('confirmed', confirmed);
  installDecimalValidator();
}

export default {
  localizeVeeValidate,
  installVeeValidateRules,
  loadLocale,
};
